module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('h2', {
    staticClass: "ui center aligned icon header"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.icon
  }), _vm._v("\n    " + _vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds) + "\n    "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.play
    }
  }, [_c('i', {
    staticClass: "play icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "pause icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.backward
    }
  }, [_c('i', {
    staticClass: "step backward icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.forward
    }
  }, [_c('i', {
    staticClass: "step forward icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.plus
    }
  }, [_c('i', {
    staticClass: "step plus icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.minus
    }
  }, [_c('i', {
    staticClass: "step minus icon"
  })]), _vm._v(" "), _c('button', {
    staticClass: "ui mini icon button",
    on: {
      "click": _vm.toggleSettings
    }
  }, [_c('i', {
    staticClass: "setting icon"
  })])]), _vm._v(" "), (_vm.showSettings) ? _c('Settings', {
    attrs: {
      "settings": _vm.settings
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a00462","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timer.vue
// module id = 25
// module chunks = 0